import React, { Component } from "react";
import { withAppState, getAppState } from "../../state";
import { getSdk } from "../../services/sdkService";
import { config } from "../../config/config";
import {
  Title,
  PauseScreen,
  Tracks,
  Text,
  Button,
  AdTag,
  Filmstrip,
  withFocusable,
  PlaybackRate,
  Loading,
  Image,
  PauseAdScreen
} from "../../services/visualLibraryService";
import { PlayerShadow, PlayerShadowAds } from "../Player/styles/Styled";

import {
  playerUiStates,
  onStateEnter,
  setPlayerLoadTimer,
  destroyPlayerLoadTimer,
  showMiniPlayer,
  hideMiniPlayer
} from "../Player/playerStates";
import { getLogger } from "../../utils/logger";
import { CHANNEL_TYPES, WIDEVINE_FORMATS, DPLAY } from "../../utils/epgUtil";
import { updateTracksState, extendTrackInfo } from "../Player/tracks";
import { checkDevice, sendMaxDevicesReport } from "../Player/devices";
import { getPlayerErrorMessage, getPlayerErrorMessageHeading, sendPlayerErrorReport } from "../Player/playerErrors";
import { sendUserEvent } from "../../services/analyticsService";
import { Player, PlayerEvent } from "bitmovin-player";
import { SubtitleOverlay, SeekBar, UIContainer, UIManager } from "bitmovin-player-ui";
import { i18n } from "../../services/i18nService";
import { showForceLogoutError, showQRCodeModal } from "../../services/modalsService";
import { getErrorCode, createErrorMapper, normalizeLang } from "../PlayerBitmovin/bitmovinErrorMapper";
import {
  requestAdPostCall,
  requestAdGetCall,
  parseTrackerCallData,
  getCurrentUTCTimestamp
} from "../PlayerBitmovin/adApiCalls";
import { getTVODInitStatus } from "../../utils/tvodUtils";
import { PlayerDiv, LowerPlayerControlsAdsMiniPlayer, AdInfoStyleMiniPlayer } from "./livePlayerStyles/styled";
import { isGuestUserLoggedIn, getGuestUserID } from "../../utils/guestProfileUtil";
import { SIGNATURE_KEY_STG, SIGNATURE_KEY_PROD, getSignatureKeyV1 } from "../../services/tvodService";
import {
  getConcurrency,
  getSuperParentAddOnNameForConcurrency,
  isInitiateConcurrencyFlow
} from "../../utils/concurrencyUtils";
import {
  Wrapper,
  LowerPlayerControls,
  PlayPauseToggle,
  ToggleBtn,
  FillBtnPlay,
  FillBtnPause,
  CurrentPlay,
  TotalPlayTime,
  CurrentAndTotalPlaySpan,
  ProgressBarContainer,
  ProgressBar,
  ProgressBarContainerAd,
  ProgressBarAd,
  ControlsSettingsStyled,
  LabelDiv,
  LabelStyled,
  ControlSettingsBtn,
  ButtonsAdsStyled,
  FillBtnBack,
  FillBtnLanguage,
  FillBtnStart,
  AdInfoStyled,
  AdTextStyled,
  AdBreaksListStyled,
  AdBreaksStyled,
  AdDotStyled,
  LowerPlayerControlsAds,
  NextPlayBackShade
} from "../PlayerBitmovin/styled";
import { ButtonStyled } from "../../components/ModalSettings/styles/Styled";
import DefaultChannelImage from "../../components/EPG/PlayerPlaceholder/epgdefaultchannelimage1.png";
import DefaultChannelImageLeft from "../../components/EPG/PlayerPlaceholder/epgdefaultchannelimageleft.png";
import {
  getYouboraParamsForBytePlus,
  sendStayEventForBytePlus,
  extractHisenseVersion
} from "../../services/byteEventService";
// import { SkipAdButton } from "../PlayerBitmovin/styled.js";
import { getWidevineURL } from "../../services/configService";
import { getPauseAd, impressionTracking } from "../../services/sponsorAdService";
import { changeState } from "../Player/playerStates";
import { makeBaseContentAsStarzplay } from "../../utils/commonUtils";
import { parseQueryString } from "../../helpers/parseQueryString";
import { getCurrentProfile } from "../../services/multipleProfilesService";
import getBrands from "../../services/layoutService";
import { getAddonsListWithBase } from "../../services/layoutService";
import { getDeviceName } from "../../utils/mobileLiteUtils";
import { RTL } from "../../e2e/utils/constants";
import { setHeartBeatTimer } from "../../services/heartbeatService";

let sdk = null;
let playbackToken = "";
let playbackTokenNonDRM = "";
let Logger;
const SEND_TO_PHONE = "SendToPhone";
const SEND_TO_PHONE_ICON_FOCUS = "send_to_phone_focused";
const SEND_TO_PHONE_ICON = "send_to_phone";
// const SKIP_AD = "SkipAd";
const SKIP_AD_ICON_FOCUS = "skip_ad_focused";
const SKIP_AD_ICON = "skip_ad";
const DISCONNECTIVIITY_INTERNET_ERROR_CODE = "571145";
const PAUSE_AD_FOCUS = "playerThumbnail";
const PAUSE_AD_BUTTON_FOCUS = "visitSite";
const AVOD = "AVOD";
const SVOD = "SVOD";
const CLOSE_BUTTON_FOCUS = "globalModalCloseFocusPath_passThru";
const FilmstripFocus = withFocusable(Filmstrip);
const AdButtonFocus = withFocusable(Button);
// const SkipAdButtonFocus = withFocusable(SkipAdButton);
const ButtonFocus = withFocusable(ButtonStyled);
const defaultFocusPath = "video";
const STUFFSKIPAD = 0;
const NEXTINPLAYLIST = "nextPlayBack";
const STUFFSKIPADONLAST = 3;
const BUTTONS_LABELS = ["pausePlay", "back", "audioSubtitles", "playFromBeginning"];
const DELAY_TIMEOUT = 3000;
const VAULTO_CALL_ERROR_CODE = "571144";
const NODRM_CALL_ERROR_CODE = "571143";

var hidden, visibilityChange;

if (typeof document.hidden !== "undefined") {
  // To support the standard web browser engine
  hidden = "hidden";
  visibilityChange = "visibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
  // To support the webkit engine
  hidden = "webkitHidden";
  visibilityChange = "webkitvisibilitychange";
}
class LivePlayer extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    sdk = getSdk();
    Logger = getLogger();
    sdk.playerManager.destroy();
    this.state = {
      player: null,
      isPlayerLoaded: false,
      isPlaying: true,
      isSeeked: false,
      seekedTime: 0,
      duration: "00:00",
      currentTime: "00:00",
      currentTimeInSeconds: 0,
      totalTimeInSeconds: 0,
      showPauseScreen: false,
      playbackRate: 0,
      firstLoad: true,
      margin: i18n.getDirection() === "ltr" ? 2 : 1,
      textLabels: [
        "",
        i18n.get("global.back"),
        i18n.get("pages.player.settings.audioSubtitles"),
        i18n.get("global.playFromBeginning")
      ],
      playerBuffering: true,
      openTracksAndAudio: false,
      showFilmStrip: false,
      subtitleTracks: null,
      audioTracks: null,
      filmstripData: null,
      currentSubtitleID: null,
      isMaxDeviceReached: false,
      showPlayerControls: true,
      errorMessage: null,
      errorMessageHeading: null,
      isTryToplayFromResume: true,
      title: this.props.videoData.title,
      description: this.props.videoData.description,
      pauseAd: null,
      isImageLoadError: false
    };

    this.config = {
      refCanStartPlayback: null
    };
    this.wheelState = "idle";
    this.requestAdUrl = null;
    this.trackingHostUrl = null;
    this.manifestHostUrl = null;

    this.isForcedAd = false;
    this.isForcedAdFomCW = false;
    this.isForcedAdIndex = 0;
    this.isPlayfromStartCW = false;
    this.filterAdData = [];
    this.adBreaksStartTimes = [];
    this.adBreaksEndTimes = [];
    this.adBreaksIndexes = [];
    this.adMargin = [];
    this.adBreakCounter = 0;
    this.storedSeekedTime = 0;
    this.adCounter = 0;
    this.adDuration = "00:00";
    this.totalAdsInAdBreak = 0;
    this.adDurationinSeconds = 0;
    this.adDurationSetTimeInterval = 0;
    this.isAdUIShown = false;
    this.isAdbreakFinish = false;
    this.adSeekTime = 0;
    this.retryCount = 0;
    this.playlistCounter = 0;
    this.adTimeInterval = null;
    this.isAdStalled = false;
    this.isFullScreenFirstTime = true;
    this.isLivePlayBackStart = false;
    this.seekedInAd = false;
    this.adCountry = getAppState().country.toUpperCase();
    this.isPlayFromAds = false;
    this.currentAdData = null;
    this.isAdStarted = true;
    this.isStartOver = false;

    this.preferredAudioLanguage = config.get().preferredAudioLanguage;
    this.preferredSubtitlesLanguage = config.get().player.preferredSubtitlesLanguage;
    this.playbackPercentages = [...config.get().player.playbackPercentages];
    this.timeToHideUI = config.get().player.timeToHideUI;
    this.timeToShowPauseScreen = config.get().player.timeToShowPauseScreen;
    this.xRequestId = "";

    createErrorMapper();
    this.filmstrip = null;
    this.errorButtonClose = null;
    this.showPauseScreenInterval = null;
    this.showHidePlayerControls = null;
    this.previousSecond = null;
    this.playbackTimes = null;
    this.appFlow = i18n.getDirection(); //LTR or RTL
    this.playbackIconName = "";
    this.isHeartBeatLoaded = null;
    this.bindings();

    document.addEventListener(visibilityChange, this.onVisibilityChange);
  }

  async componentDidUpdate(prevProps, prevState) {
    const { isProfileDelete } = this.props.applicationState;
    if (isProfileDelete) {
      this.player.unload();
      this.player.destroy();
    }
    if (!this.state.firstLoad) {
      if (prevProps.isFullScreen !== this.props.isFullScreen) {
        if (this.props.isFullScreen === false) {
          if (!this.state.isPlaying) {
            this.setState(
              {
                isPlaying: true,
                selectBtn: this.props.videoData.isLive ? 1 : 0,
                showFilmStrip: false,
                openTracksAndAudio: false,
                showPlayerControls: true,
                showPauseScreen: false,
                playerBuffering: false,
                isPlayerLoaded: true,
                subtitleTracks: null,
                margin: i18n.getDirection() === "ltr" ? 2 : 1,
                pauseAd: null
              },
              () => {
                clearInterval(this.showPauseScreenInterval);
                clearTimeout(this.showHidePlayerControls);
                this.showControls();
                this.showProgressBar();
                this.player.play();
              }
            );
          }
          this.isFullScreenFirstTime = true;
        } else if (this.props.isFullScreen === true) {
          this.setState(
            {
              isPlaying: true,
              selectBtn: this.props.videoData.isLive ? 1 : 0,
              showFilmStrip: false,
              openTracksAndAudio: false,
              showPlayerControls: true,
              showPauseScreen: false,
              playerBuffering: false,
              isPlayerLoaded: true,
              margin: i18n.getDirection() === "ltr" ? 2 : 1
            },
            () => {
              clearInterval(this.showPauseScreenInterval);
              clearTimeout(this.showHidePlayerControls);
              this.showControls();
              this.showProgressBar();
              this.player.play();
            }
          );
        }
      }

      if (prevProps.videoData !== this.props.videoData && !this.state.firstLoad) {
        this.setState(
          {
            playerBuffering: true,
            audioTracks: null // refresh audio tracks
          },
          () => {
            this.props.onChange({
              playerBuffering: this.state.playerBuffering,
              colIndex: this.props.currentCol,
              rowIndex: this.props.currentRow,
              categoryIndex: this.props.currentCat
            });
          }
        );
        // byte+ stay event
        sendStayEventForBytePlus({
          titleId: this.config?.id,
          seriesId: this.config?.id,
          subType: this.config?.contentType || prevProps?.videoData?.contentType,
          mediaData: prevProps?.videoData,
          currentScreen: sessionStorage.getItem("currentScreen"),
          previousScreen: sessionStorage.getItem("prevScreen"),
          playerCurrentTime: this.player ? this.player.getCurrentTime() : 0
        });
        await this.refreshPlayer();
        await this.startPlayer();
      } else if (
        prevProps.playFromStart !== this.props.playFromStart ||
        prevProps.playFromResume !== this.props.playFromResume
      ) {
        if (this.props.playFromStart === true) {
          if (this.isForcedAd) this.isForcedAd = false;
          if (this.isStartOver) await this.playFromBeginning();
        } else if (
          this.props.playFromStart === false &&
          this.props.playFromResume > 0 &&
          this.props.isFullScreen === true
        ) {
          if (!this.isForcedAdFomCW) await this.playFromResume();
        }
      }
      // Adtech Project - Setting Focus when Epg Refresh - Start
      if (prevProps.isEpgRefresh !== this.props.isEpgRefresh && this.state.pauseAd) {
        this.props.setFocus(PAUSE_AD_FOCUS);
      }
      // Adtech Project - Setting Focus when Epg Refresh - End
    }
  }

  async componentDidMount() {
    sessionStorage.removeItem("refCarouselRecVariant"); // reset the value so that rec_variant value is correctly passed in live page.
    if (this.state.firstLoad) {
      await this.refreshPlayer();
      await this.startPlayer();
      this.setState({
        firstLoad: false
      });
    }
  }

  componentWillUnmount() {
    // byte+ stay event
    sendStayEventForBytePlus({
      titleId: this.config?.id,
      seriesId: this.config?.id,
      subType: this.config?.contentType || this.props?.videoData?.contentType,
      mediaData: this.props?.videoData,
      currentScreen: sessionStorage.getItem("curPageForLive"),
      previousScreen: sessionStorage.getItem("prevPageForLive"),
      playerCurrentTime: this.player ? this.player.getCurrentTime() : 0
    });
    this.refreshPlayer();
  }

  async checkMaxDevices() {
    const { maxDevices } = config.get().featureToggles;
    if (maxDevices && this.props.videoData?.videoType !== "trailer") {
      try {
        const { freeDeviceSlotsExist, maximumDevicesAllowed, deviceAlreadyRegistered } = await checkDevice.call(this);
        if (!freeDeviceSlotsExist && !deviceAlreadyRegistered) {
          let error = {
            code: "571102",
            data: {
              name: "Device Limit Reached"
            }
          };
          this.setState({ nextPlayBackShade: false }, () => {
            this.props.onChange({
              isError: true,
              errorHeading: i18n.get("pages.player.errorTitle.concurrencyErrorTitle"),
              errorMessage: i18n.get("pages.player.errors.maximumDevicesReached", maximumDevicesAllowed),
              colIndex: this.props.currentCol,
              rowIndex: this.props.currentRow,
              categoryIndex: this.props.currentCat
            });
          });
          sdk.playerManager.willStop();
          sdk.playerManager.stop();
          this.player.pause();
          this.player.unload();
          this.playerErrorHandler(error);
          sendMaxDevicesReport.call(this);
          return true;
        }
      } catch (e) {
        await this.props.stateActions.setForceLogout({ status: e.code });
        // if Force logout show the popup
        if (!!getAppState().forceLogout) {
          this.props.resumeNavigation();
          await showForceLogoutError.call(this);
          return;
        }
        this.showErrorModal(e.message);
        return true;
      }
    }
    return false;
  }

  async startPlayer(next = null) {
    sdk = await getSdk();
    this.retryCount = 0;
    await this.updateConfig();
    this.setState({
      title: this.props.videoData.title,
      description: this.props.videoData.description,
      selectBtn: next === null ? (this.props.videoData.isLive ? 1 : 0) : -1,
      totalBtns: this.props.videoData.isLive ? 2 : 3
    });

    (async () => {
      try {
        if (!!getAppState().forceLogout) {
          await showForceLogoutError.call(this);
          return;
        }
        showMiniPlayer();
        this.clearUserMediaCached();
      } catch (e) {
        await this.props.stateActions.setForceLogout(e);
        // if Force logout show the popup
        if (!!getAppState().forceLogout) {
          await showForceLogoutError.call(this);
          return;
        }
        this.showErrorModal(e.message);
        return;
      }
      try {
        Logger.log(this.config.manifest, "Manifest");
        this.setupPlayer();
      } catch (e) {
        Logger.log(
          `Requesting error message for error: ${e.code} after failure in playerManager.setup`,
          "Player.componentDidMount"
        );
      }
      document.addEventListener("keyup", this.handleRemoteKeys, false);
      document.addEventListener("keydown", this.handleRemoteKeysFilmstrip, false);
      !!getAppState().globalModal && this.props.stateActions.hideGlobalModal();
      // byte+
      var bytePlusYouboraData = await getYouboraParamsForBytePlus({
        titleId: this.config.id,
        currentScreen: sessionStorage.getItem("currentScreen"),
        previousScreen: sessionStorage.getItem("prevScreen")
      });
      this.config.playbackAnalytics = {
        ...this.config.playbackAnalytics,
        title: null || this.state.title
      };
      this.config = { ...this.config, ...bytePlusYouboraData };
    })();
  }

  async refreshPlayer(next = null) {
    document.removeEventListener("keyup", this.handleRemoteKeys, false);
    document.removeEventListener("keydown", this.handleRemoteKeysFilmstrip, false);
    sessionStorage.setItem("fromEpg", "no");
    hideMiniPlayer();
    this.filterAdData = [];
    this.adBreaksStartTimes = [];
    this.adBreaksEndTimes = [];
    this.requestAdUrl = null;
    this.trackingHostUrl = null;
    this.manifestHostUrl = null;
    sdk.playerManager.stop(false);
    sdk.playerManager.destroy();
    //Removing all Event Handlers
    if (this.player && this.player !== null) {
      this.player.off(PlayerEvent.Seek, this.seekEventHandler);
      this.player.off(PlayerEvent.Playing, this.playEventHandler);
      this.player.off(PlayerEvent.PlaybackFinished, this.playbackFinishedEventHandler);
      this.player.off(PlayerEvent.TimeChanged, this.timeChangedEventHandler);
      this.player.off(PlayerEvent.Error, this.playerErrorEventHandler);
      this.player.off(PlayerEvent.StallStarted, this.stallStartedEventHandler);
      this.player.off(PlayerEvent.StallEnded, this.stallEndedEventHandler);
      document.removeEventListener(visibilityChange, this.onVisibilityChange);
      this.resetAdsPlayer();
      this.setState({ subtitleTracks: null });
    }
    this.player && this.player.off(PlayerEvent.Seeked, this.seekedHandler);
    destroyPlayerLoadTimer.call(this);
    //if (next !== NEXTINPLAYLIST) {
    this.player && this.player.unload();
    this.player && this.player.destroy();
    // }
  }
  resetAdsPlayer() {
    clearInterval(this.adTimeInterval);
    // clearTimeout(this.skipDisableTimer);
    this.filterAdData = [];
    this.adBreaksStartTimes = [];
    this.adBreaksEndTimes = [];
    this.adBreaksIndexes = [];
    this.adMargin = [];
    this.currentAdData = null;
    this.isPlayfromStartCW = false;
    this.isAdStarted = true;
    this.adBreakCounter = 0;
    this.adCounter = 0;
    this.adDuration = "00:00";
    this.totalAdsInAdBreak = 0;
    this.adDurationinSeconds = 0;
    this.adDurationSetTimeInterval = 0;
    this.isAdUIShown = false;
    this.isAdbreakFinish = false;
    this.adSeekTime = 0;
    this.adTimeInterval = null;
    this.isPlayBackStart = false;
    this.storedSeekedTime = 0;
    this.isForcedAd = false;
    this.isForcedAdFomCW = false;
    this.isForcedAdIndex = 0;
    this.isStartOver = false;
  }

  resetAdbreak() {
    setTimeout(() => {
      this.adCounter = 0;
      this.adDurationinSeconds = 0;
      this.adSeekTime = 0;
    }, DELAY_TIMEOUT);
    this.isAdbreakFinish = false;
    clearInterval(this.adTimeInterval);
    this.adTimeInterval = null;
    // this.isSkipBtnDisabled = true;
    // clearTimeout(this.skipDisableTimer);
  }

  /**
   * Updates config information to send to the player
   */
  async updateConfig() {
    Object.assign(this.config, {
      releasePids: this.props.videoData.releasePid,
      releaseUrl: this.props.videoData.releaseUrl,
      videoType: this.props.videoData.videoType,
      contentTypeYoubora: this.props.videoData.videoType,
      dash_widevine_ads: this.props.videoData.dash_widevine_ads,
      dash_widevine_Without_ads: this.props.videoData.dash_widevine_Without_ads,
      dPlay: this.props.videoData.dPlay,
      manifest: this.props.videoData.manifest,
      adsCountryRights: this.props.videoData.adsCountryRights,
      playbackTime: this.props.videoData["playbackTime"],
      id: this.props.videoData.id.toString(),
      has4K: this.props.videoData.has4K,
      title: this.props.videoData.title,
      description: this.props.videoData.description,
      externalSubtitles: this.props.videoData.externalSubtitles,
      isLive: this.props.videoData.isLive,
      isWatchNow: this.props.videoData.isWatchNow,
      playlist: this.props.videoData.playlist,
      guid: this.props.videoData.guid,
      autoplay: this.props.autoplay,
      fullscreen: this.props.isFullScreen === true && this.props.isFullScreen,
      assetType: this.isPlayFromAds ? WIDEVINE_FORMATS.withAd : WIDEVINE_FORMATS.withoutAd,
      contentType: this.props.videoData.contentType,
      contentOwnership: this.props.videoData.contentOwnership,
      profileType: this.props.videoData.profileType,
      userid: isGuestUserLoggedIn() ? getGuestUserID() : localStorage.getItem("globalUserId"),
      package: makeBaseContentAsStarzplay(this.props.videoData.subscription[0]),
      deviceType: config.get().sdk.deviceType,
      currentPlaylistIndex: this.props.videoData.currentPlaylistIndex,
      channelType: this.props.videoData.channelType,
      isFirstPlay: getTVODInitStatus(),
      addonContent: this.props.videoData.addonContent || "starz",
      onlineContent: this.props.videoData.onlineContent || "online",
      playbackAnalytics: {
        mediaGuid: this.props.videoData.mediaGuid,
        duration: this.props.videoData.duration,
        genre: this.props.videoData.genre,
        resume: !!this.props.videoData["playbackTime"]
      }
    });
  }
  getStreamingUrlWithOutAd(streamingUrl, dPlay) {
    const formatMap = {
      [DPLAY.free]: WIDEVINE_FORMATS.withoutAdnonDrm,
      [DPLAY.token]: WIDEVINE_FORMATS.withoutAdnonDrmProtected,
      default: WIDEVINE_FORMATS.withoutAd
    };
    let format = formatMap[dPlay] || formatMap.default;
    let filteredUrls = streamingUrl.filter(type => type.assetTypes[0] === format);

    if (filteredUrls.length === 0) {
      format = WIDEVINE_FORMATS.withoutAd;
      filteredUrls = streamingUrl.filter(type => type.assetTypes[0] === format);
    }

    return filteredUrls;
  }

  getStreamingUrlWithAd(streamingUrl, dPlay) {
    const formatMap = {
      [DPLAY.free]: WIDEVINE_FORMATS.withAdnonDrm,
      [DPLAY.token]: WIDEVINE_FORMATS.withAdnonDrmProtected,
      default: WIDEVINE_FORMATS.withAd
    };
    let format = formatMap[dPlay] || formatMap.default;
    let filteredUrls = streamingUrl.filter(type => type.assetTypes[0] === format);

    if (filteredUrls.length === 0) {
      format = WIDEVINE_FORMATS.withAd;
      filteredUrls = streamingUrl.filter(type => type.assetTypes[0] === format);
    }

    if (filteredUrls.length === 0) {
      format = WIDEVINE_FORMATS.withoutAd;
      filteredUrls = streamingUrl.filter(type => type.assetTypes[0] === format);
    }

    return filteredUrls;
  }

  getStreamingUrlDefault(streamingUrl) {
    let format = WIDEVINE_FORMATS.withoutAd;
    let filteredUrls = streamingUrl.filter(type => type.assetTypes[0] === format);
    return filteredUrls;
  }

  async updateNextPlaylistItem() {
    this.playlistCounter = this.config.currentPlaylistIndex + 1;
    const nextConfig = {
      releasePids: this.props.videoData.releasePid,
      releaseUrl: this.props.videoData.releaseUrl,
      videoType: this.props.videoData.videoType,
      contentTypeYoubora: this.props.videoData.videoType,
      dash_widevine_ads:
        this.getStreamingUrlWithAd(
          this.props.videoData.playlist[this.playlistCounter].streamingUrl,
          this.props.videoData?.dPlay
        )[0] || WIDEVINE_FORMATS.withoutAd,
      dash_widevine_Without_ads:
        this.getStreamingUrlWithOutAd(
          this.props.videoData.playlist[this.playlistCounter].streamingUrl,
          this.props.videoData?.dPlay
        )[0] || WIDEVINE_FORMATS.withoutAd,

      manifest: this.getStreamingUrlDefault(this.props.videoData.playlist[this.playlistCounter].streamingUrl)[0].url,

      adsCountryRights: this.props.videoData.adsCountryRights,
      dPlay: this.props.videoData?.dPlay,
      playbackTime: 0,
      id: this.props.videoData.id.toString(),
      has4K: this.props.videoData.has4K,
      title: this.props.videoData.playlist[this.playlistCounter].title,
      description: this.props.videoData.playlist[this.playlistCounter].description,
      externalSubtitles: this.props.videoData.externalSubtitles,
      isLive: this.props.videoData.isLive,
      isWatchNow: this.props.videoData.isWatchNow,
      playlist: this.props.videoData.playlist,
      currentPlaylistIndex: this.playlistCounter,
      channelType: this.props.videoData.channelType,
      isFirstPlay: getTVODInitStatus(),
      guid: this.props.videoData.playlist[this.playlistCounter].guid,
      fullscreen: this.props.isFullScreen,
      assetType: this.isPlayFromAds ? WIDEVINE_FORMATS.withAd : WIDEVINE_FORMATS.withoutAd,
      contentType: this.props.videoData.contentType,
      contentOwnership: this.props.videoData.contentOwnership,
      profileType: this.props.videoData.profileType,
      userid: isGuestUserLoggedIn() ? getGuestUserID() : localStorage.getItem("globalUserId"),
      package: makeBaseContentAsStarzplay(this.props.videoData.subscription[0]),
      deviceType: config.get().sdk.deviceType,
      addonContent: this.props.videoData.addonContent || "starz",
      onlineContent: this.props.videoData.onlineContent || "online",
      playbackAnalytics: {
        mediaGuid: this.props.videoData.playlist[this.playlistCounter].mediaGuid,
        duration: this.props.videoData.playlist[this.playlistCounter].duration,
        genre: this.props.videoData.playlist[this.playlistCounter].genre,
        resume: !!this.props.videoData["playbackTime"]
      }
    };

    Object.assign(this.props.videoData, nextConfig);
    this.setState(
      {
        playerBuffering: true,
        nextPlayBackShade: true
      },
      () => {
        this.props.onChange({
          playerBuffering: false,
          colIndex: this.props.currentCol,
          rowIndex: this.props.currentRow,
          categoryIndex: this.props.currentCat
        });
      }
    );
    await this.refreshPlayer(NEXTINPLAYLIST);
    await this.startPlayer(NEXTINPLAYLIST);
  }

  showProgressBar() {
    if (this.state.showPauseScreen === true) {
      this.setState({
        showPauseScreen: false
      });
    }
    this.showControls();
  }

  showBar() {
    clearTimeout(this.showHidePlayerControls);
    this.setState(
      {
        showPlayerControls: true
      },
      () => {
        if (this.props.isFullScreen) this.props.actions.pauseNavigation();
      }
    );
  }

  showControls() {
    clearTimeout(this.showHidePlayerControls);
    this.setState(
      {
        showPlayerControls: true
      },
      () => {
        if (this.props.isFullScreen) this.props.actions.pauseNavigation();
      }
    );

    if (!this.state.showFilmStrip) {
      this.showHidePlayerControls = setTimeout(() => {
        this.setState(
          {
            showPlayerControls: false,
            openTracksAndAudio: false,
            selectBtn: this.props.videoData.isLive ? 1 : 0,
            margin: i18n.getDirection() === "ltr" ? 2 : 1
          },
          () => {
            if (this.props.isFullScreen) this.props.actions.pauseNavigation();
          }
        );
      }, this.timeToHideUI);
    }
  }

  openLanguage() {
    this.loadSubtitlesTracks();
    this.loadAudioTracks();
    this.setState(
      {
        openTracksAndAudio: true
      },
      () => {
        if (this.props.isFullScreen) this.props.actions.resumeNavigation();
      }
    );
  }

  async playFromBeginning() {
    this.playFromStart();
  }

  async playFromResume() {
    this.player.pause();
    this.setState(
      {
        seekedTime: this.props.playFromResume
      },
      () => this.player.seek(this.state.seekedTime)
    );
    // setTimeout(() => {
    //   this.player.play();
    // }, 3000);
    this.playFromStartSeekedEventHandler();
  }

  async handleRemoteKeys(event) {
    if (this.props.isFullScreen === false) return;
    const { isLive } = this.props.videoData;
    this.wheelState = "idle";
    if (this.state.playerBuffering) return;
    if (this.shouldShowLoading()) return;
    if (event.keyCode === 13 && this.state.selectBtn !== -1) {
      // OK button
      if (this.state.openTracksAndAudio) return;
      if (this.props.isFullScreen && this.isFullScreenFirstTime) {
        this.isFullScreenFirstTime = false;
        return;
      }

      if (this.isAdUIShown === false) {
        if (this.state.selectBtn === 0 && !this.isFullScreenFirstTime) {
          /** Fix Me: commented out because need to pause video first time 
            if (this.isFullScreenFirstTime === true) {
              this.doNothing();
            } else {
              await this.togglePausePlay();
            }
            this.isFullScreenFirstTime = false;
          */
          await this.togglePausePlay();
        } else if (!this.state.showFilmStrip && this.state.selectBtn === 2) {
          this.loadSubtitlesTracks();
          this.loadAudioTracks();
          this.setState(
            {
              openTracksAndAudio: true
            },
            () => {
              if (this.props.isFullScreen) this.props.actions.resumeNavigation();
            }
          );
        } else if (!this.state.showFilmStrip && this.state.selectBtn === 3) {
          // start play button
          this.playFromStart();
        }
      }
    } else if (event.keyCode === 38) {
      // up button
      if (
        // this.state.isPlaying === false ||
        this.isAdUIShown === true ||
        this.state.openTracksAndAudio ||
        this.state.showFilmStrip
      )
        return;
      if (this.state.showPlayerControls === true && this.state.selectBtn === 0 && this.state.isPlaying) {
        this.setState(
          {
            selectBtn: 1,
            margin: i18n.getDirection() === "ltr" ? 2 : 1
          },
          () => {
            this.props.onChange({
              onFullScreen: true,
              buttonEnter: BUTTONS_LABELS[this.state.selectBtn],
              colIndex: this.props.currentCol,
              rowIndex: this.props.currentRow,
              categoryIndex: this.props.currentCat
            });
          }
        );
      }
      if (this.state.pauseAd && !this.props.showQRCodeModal) {
        this.props.setFocus(PAUSE_AD_FOCUS);
      }
      this.showControls();
    } else if (event.keyCode === 40) {
      // down button
      if (this.state.openTracksAndAudio || this.isAdUIShown === true || this.state.showFilmStrip) return;
      if (this.state.selectBtn > 0 && this.props.videoData.isLive === false) {
        this.setState(
          {
            selectBtn: 0,
            margin: i18n.getDirection() === "ltr" ? 2 : 1
          },
          () => {
            this.props.onChange({
              onFullScreen: true,
              buttonEnter: BUTTONS_LABELS[this.state.selectBtn],
              colIndex: this.props.currentCol,
              rowIndex: this.props.currentRow,
              categoryIndex: this.props.currentCat
            });
          }
        );
      }
      if (this.state.pauseAd && !this.props.showQRCodeModal) {
        this.props.setFocus(PAUSE_AD_BUTTON_FOCUS);
      }
      this.showControls();
    } else if (event.keyCode === 415) {
      // play button on remote
      if (this.isAdUIShown === true) return;
      if (!this.state.isSeeked && this.state.isPlaying === false) {
        this.setState(
          {
            isPlaying: true,
            selectBtn: 0,
            showFilmStrip: false,
            openTracksAndAudio: false
          },
          () => {
            if (this.props.isFullScreen) this.props.actions.pauseNavigation();
          }
        );
        this.player.play();
        clearInterval(this.showPauseScreenInterval);
        this.setState({
          showPauseScreen: false
        });
        this.showControls();
      } else if (this.state.isSeeked) {
        this.player.pause();

        if (this.isForcedAd) {
          let startTime = this.adBreaksStartTimes[this.isForcedAdIndex];
          this.storedSeekedTime = this.state.seekedTime;
          this.player.seek(startTime - STUFFSKIPAD);
        } else {
          this.player.seek(this.state.seekedTime);
        }
      }
    } else if (event.keyCode === 19) {
      //pause button on remote
      if (this.isAdUIShown === true) return;
      if (!this.state.isSeeked && this.state.isPlaying === true) {
        this.setState(
          {
            isPlaying: false,
            selectBtn: 0,
            showFilmStrip: false,
            openTracksAndAudio: false
          },
          () => {
            if (this.props.isFullScreen) this.props.actions.pauseNavigation();
          }
        );
        !isLive && this.player.pause();
        this.showPauseScreenInterval = setInterval(() => {
          this.setState({
            showPauseScreen: true
          });
        }, this.timeToShowPauseScreen);
      }
    }
  }
  handleRemoteKeysFilmstrip(event) {
    if (this.props.isFullScreen === false) return;
    const { isLive } = this.props.videoData;
    if (this.state.pauseAd) return;
    if (this.state.playerBuffering) return;
    if (this.isAdUIShown === true) return;
    if (this.shouldShowLoading()) return;
    this.state.showFilmStrip && !this.props.videoData.isLive && this.player.pause();
    if (event.keyCode === 37) {
      //left button
      this.showControls();
      if (this.state.openTracksAndAudio) return;
      if (this.appFlow === "ltr" && !this.state.showFilmStrip && this.state.selectBtn > 1) {
        this.setState(
          {
            selectBtn: this.state.selectBtn - 1,
            margin: this.state.margin - 4.5
          },
          () => {
            this.props.onChange({
              onFullScreen: true,
              buttonEnter: BUTTONS_LABELS[this.state.selectBtn],
              colIndex: this.props.currentCol,
              rowIndex: this.props.currentRow,
              categoryIndex: this.props.currentCat
            });
          }
        );
      } else if (
        this.appFlow === "rtl" &&
        !this.state.showFilmStrip &&
        this.state.selectBtn > 0 &&
        this.state.selectBtn < this.state.totalBtns
      ) {
        this.setState(
          {
            selectBtn: this.state.selectBtn + 1,
            margin: this.state.margin + 4.5
          },
          () => {
            this.props.onChange({
              onFullScreen: true,
              buttonEnter: BUTTONS_LABELS[this.state.selectBtn],
              colIndex: this.props.currentCol,
              rowIndex: this.props.currentRow,
              categoryIndex: this.props.currentCat
            });
          }
        );
      } else if (this.state.selectBtn === 0) {
        !isLive && this.seekLeft();
      }
    } else if (event.keyCode === 39) {
      // right button
      this.showControls();
      if (this.state.openTracksAndAudio) return;

      if (
        this.appFlow === "ltr" &&
        !this.state.showFilmStrip &&
        this.state.selectBtn > 0 &&
        this.state.selectBtn < this.state.totalBtns
      ) {
        this.setState(
          {
            selectBtn: this.state.selectBtn + 1,
            margin: this.state.margin + 4.5
          },
          () => {
            this.props.onChange({
              onFullScreen: true,
              buttonEnter: BUTTONS_LABELS[this.state.selectBtn],
              colIndex: this.props.currentCol,
              rowIndex: this.props.currentRow,
              categoryIndex: this.props.currentCat
            });
          }
        );
      } else if (this.appFlow === "rtl" && !this.state.showFilmStrip && this.state.selectBtn > 1) {
        this.setState(
          {
            selectBtn: this.state.selectBtn - 1,
            margin: this.state.margin - 4.5
          },
          () => {
            this.props.onChange({
              onFullScreen: true,
              buttonEnter: BUTTONS_LABELS[this.state.selectBtn],
              colIndex: this.props.currentCol,
              rowIndex: this.props.currentRow,
              categoryIndex: this.props.currentCat
            });
          }
        );
      } else if (this.state.selectBtn === 0) {
        !isLive && this.seekRight();
      }
    }
    if (event.keyCode === 412) {
      //rewind button on remote
      this.state.selectBtn === 0 && this.seekLeft();
    } else if (event.keyCode === 417) {
      //forward button on remote
      this.state.selectBtn === 0 && this.seekRight();
    }
  }

  onVisibilityChange = () => {};
  // getting internal bitmovin audio track
  loadAudioTracks() {
    const newState = {};
    const availableAudioTrack = this.player.getAvailableAudio();
    if (!this.state.audioTracks) {
      newState.audioTracks = extendTrackInfo(
        sdk.playerManager.getAvailableAudioTracks(availableAudioTrack),
        normalizeLang(this.preferredAudioLanguage),
        true
      );
    }
    this.setState(newState);
    this.props.stateActions.hideGlobalModal();
  }

  /**
   * Gets the information for the subtitles menu and selects the selected subtitle in the menu
   */
  loadSubtitlesTracks() {
    const newState = {};
    const { isLive } = this.props.videoData;
    const availableTextTracks = this.player.subtitles.list();
    if (!this.state.subtitleTracks && !isLive) {
      newState.subtitleTracks = extendTrackInfo(
        sdk.playerManager.getAvailableSubtitleTracks(availableTextTracks),
        normalizeLang(this.preferredSubtitlesLanguage),
        true
      );
      for (let i = 0, l = newState.subtitleTracks.length; i < l; i++) {
        const track = newState.subtitleTracks[i];
      }
    } else if (isLive) {
      newState.subtitleTracks = [
        {
          language: "off",
          selected: true,
          title: "None"
        }
      ];
    } else if (this.state.subtitleTracks && !isLive) {
      newState.subtitleTracks = this.state.subtitleTracks;
    }
    this.setState(newState);
  }

  updateSubtitleContainerDirection = language => {
    if (language === "ar" || language === "ur") {
      const element = document.querySelector(".bmpui-container-wrapper");
      element.setAttribute("dir", "rtl");
      element.classList.add("sans-serif-font-family");
    } else {
      const element = document.querySelector(".bmpui-container-wrapper");
      element.setAttribute("dir", "ltr");
      element.classList.remove("sans-serif-font-family");
    }
  };

  /**
   * Selects audio and subtitle track
   * @param {Object} selectedTrack
   */
  selectTrack(selectedTrack) {
    const preferredLanguage = this.props.applicationState.preferredLanguage;
    if (selectedTrack.type === "TEXT") {
      let playerTracks = this.player.subtitles.list();
      if (!playerTracks.some(track => track.lang === "off" && track.kind === "subtitle")) {
        playerTracks.push({ kind: "subtitle", lang: "off" });
      }
      let selectedSubtitle = null;
      if (selectedTrack.index >= 0) {
        try {
          this.player.subtitles.disable(this.state.currentSubtitleID);
        } catch (e) {}
        for (let i = 0; i < playerTracks.length; i++) {
          selectedSubtitle = playerTracks[i];
          if (normalizeLang(selectedTrack.lang) === normalizeLang(selectedSubtitle.lang)) {
            this.player.subtitles.enable(selectedSubtitle.id);
            this.setState({
              currentSubtitleID: selectedSubtitle.id,
              subtitleTracks: updateTracksState(this.state.subtitleTracks, selectedTrack)
            });
            sdk.playerManager.updatePreferences({ subtitles: normalizeLang(selectedTrack.lang) });
            if (preferredLanguage?.playback) preferredLanguage.playback.subtitles = normalizeLang(selectedTrack.lang);
            break;
          }
        }
        this.updateSubtitleContainerDirection(selectedTrack.lang);
      } else {
        this.player.subtitles.disable(this.state.currentSubtitleID);
        this.setState({
          subtitleTracks: updateTracksState(this.state.subtitleTracks, selectedTrack)
        });
        sdk.playerManager.updatePreferences({ subtitles: normalizeLang(selectedTrack.lang) });
        if (preferredLanguage?.playback) preferredLanguage.playback.subtitles = normalizeLang(selectedTrack.lang);
      }
    } else if (selectedTrack.type === "AUDIO") {
      const availableAudioTrack = this.player.getAvailableAudio();
      this.player.setAudio(availableAudioTrack[selectedTrack.index].id);
      sdk.playerManager.updatePreferences({ audio: normalizeLang(selectedTrack.lang) });
      if (preferredLanguage?.playback) preferredLanguage.playback.audio = normalizeLang(selectedTrack.lang);
      this.setState({
        audioTracks: updateTracksState(this.state.audioTracks, selectedTrack)
      });
    }
  }

  isAdexists() {
    const isSVODUser = getAppState()?.isSvodUser;
    const isShowAds = !isSVODUser ? true : this.props.videoData?.enforceAds && isSVODUser ? true : false;
    if (
      this.config.adsCountryRights &&
      this.config.adsCountryRights.indexOf(this.adCountry) > -1 &&
      this.config.dash_widevine_ads &&
      isShowAds
    ) {
      return true;
    } else {
      return false;
    }
  }

  async setupPlayer() {
    const streamingUrl = this.config.manifest;
    await sdk.playerManager.setup(this.config);
    let self = this;
    const playerConfig = {
      key: "9c89f7d3-2fe7-4986-aaaf-dacaf8f37b93",
      playback: {
        autoplay: true,
        muted: false,
        preferredTech: [
          {
            player: "html5",
            streaming: "dash"
          }
        ]
      },
      ui: false, // disable the built-in UI
      adaptation: {
        desktop: {
          preload: true
        }
      },
      tweaks: {
        file_protocol: true,
        app_id: "d5y9d1orz6.starz",
        MINIMAL_BACKWARD_BUFFER_CLEARING_INTERVAL: 10,
        XHR_TIMEOUT: 120, // Timeout in seconds
        PROACTIVE_GAP_SKIP_DISTANCE_SECONDS: 0.1,
        dash_clear_buffers_on_period_switches: true,
        max_mpd_retries: 15,
        max_cdn_retries: 15,
        max_retries: 15
      },
      buffer: {
        video: {
          forwardduration: 32,
          backwardduration: 10
        },
        audio: {
          forwardduration: 32,
          backwardduration: 10
        }
      },
      network: {
        preprocessHttpResponse(type, response) {
          if (response && response.headers && response.headers["x-request-id"]) {
            self.xRequestId = response.headers["x-request-id"];
          }
          return response;
        }
      }
    };

    if (this.isAdexists()) {
      const urls = this.config.dash_widevine_ads?.url?.split("?");
      if (urls) {
        try {
          this.requestAdUrl = urls[0];
          const adUrls = urls[1]?.split("&");
          const manifestHost = adUrls[0]?.split("=");
          const trackingHost = adUrls[1]?.split("=");
          this.manifestHostUrl = manifestHost[1];
          this.trackingHostUrl = trackingHost[1];
          let nonce = await this.generateNonce(this.requestAdUrl);
          let duration = this.config.playbackAnalytics.duration || 0;
          let name = this.config.playbackAnalytics.mediaGuid
            ? this.config.playbackAnalytics.mediaGuid
            : this.props.videoData.guid;
          let requestUrlresponse = await requestAdPostCall(
            this.requestAdUrl,
            nonce,
            duration,
            name,
            await this.getExtraParms()
          );
          if (!requestUrlresponse) {
            this.isPlayFromAds = false;
            this.loadSource(playerConfig, streamingUrl);
          } else {
            // AVOD non DRM protected check
            if (this.props.videoData.dPlay === DPLAY.token) {
              await this.getNonDrmToken(decodeURIComponent(this.manifestHostUrl));
              const manifestParams = (playbackTokenNonDRM && playbackTokenNonDRM.manifestParams) || "";
              this.manifestHostUrl = `${decodeURIComponent(
                this.manifestHostUrl + requestUrlresponse.manifestUrl
              )}&${parseQueryString(manifestParams)}`;
            } else {
              this.manifestHostUrl = decodeURIComponent(this.manifestHostUrl + requestUrlresponse.manifestUrl);
            }
            this.trackingHostUrl = decodeURIComponent(this.trackingHostUrl + requestUrlresponse.trackingUrl);
            this.isPlayFromAds = true;
            Object.assign(this.config, {
              manifest: this.manifestHostUrl
            });
            this.loadSource(playerConfig, this.manifestHostUrl);
          }
        } catch (e) {
          this.isPlayFromAds = false;
          this.loadSource(playerConfig, streamingUrl);
        }
      } else {
        this.isPlayFromAds = false;
        this.loadSource(playerConfig, streamingUrl);
      }
    } else {
      this.isPlayFromAds = false;
      // non AVOD non DRM Protected Check
      if (this.props.videoData.dPlay === DPLAY.token) {
        let dashURL = this.config && this.config.dash_widevine_Without_ads && this.config.dash_widevine_Without_ads.url;
        await this.getNonDrmToken(dashURL);
        let manifestParams = (playbackTokenNonDRM && playbackTokenNonDRM.manifestParams) || "";
        let tokanizeURL = `${dashURL}?${parseQueryString(manifestParams)}`;
        this.loadSource(playerConfig, tokanizeURL);
      } else {
        this.loadSource(playerConfig, streamingUrl);
      }
    }

    const preferredLanguage = this.props.applicationState.preferredLanguage;
    if (preferredLanguage?.playback) {
      this.preferredAudioLanguage = preferredLanguage.playback.audio;
      this.preferredSubtitlesLanguage = preferredLanguage.playback.subtitles;
    }
    // Device Limit Reached Check
    if (getAppState().userLogged && this.config?.contentType !== AVOD) {
      await this.checkMaxDevices();
    }
  }

  generateNonce() {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 256; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  async getExtraParms() {
    const deviceName = await getDeviceName();
    const osVersion = await extractHisenseVersion();
    return {
      app_name: "STARZPLAY",
      contentOwnership: this.props.videoData.contentOwnership,
      genre: this.props.videoData?.genres?.[0] ?? null,
      content_language: this.props.videoData.content_language,
      content_rating: this.props.videoData.content_rating,
      device_make: this.props.applicationState.deviceModel,
      device_make: deviceName,
      device_model: this.props.videoData.device_model,
      os_version: osVersion,
      entitlements: getAddonsListWithBase()
    };
  }

  loadPreferredSubtitletracks() {
    let selectedSubtitle = null;
    for (let i = 0; i < this.player.subtitles.list().length; i++) {
      selectedSubtitle = this.player.subtitles.list()[i];
      if (normalizeLang(this.preferredSubtitlesLanguage) === normalizeLang(selectedSubtitle.lang)) {
        this.player.subtitles.enable(selectedSubtitle.id);
        this.setState({
          currentSubtitleID: selectedSubtitle.id
        });
        this.updateSubtitleContainerDirection(normalizeLang(selectedSubtitle.lang));
        break;
      }
    }
  }
  //TODO : Audio Language user Prefered is updated
  loadPreferredAudiotracks() {
    const availableAudioTrack = this.player.getAvailableAudio();
    let matchedTrack = null;
    for (let i = 0; i < availableAudioTrack.length; i++) {
      if (normalizeLang(this.preferredAudioLanguage) === normalizeLang(availableAudioTrack[i].lang)) {
        this.player.setAudio(availableAudioTrack[i].id);
        matchedTrack = availableAudioTrack[i].id;
        break;
      }
    }
    if (!matchedTrack) {
      this.player.setAudio(availableAudioTrack[availableAudioTrack.length - 1].id);
    }
  }

  adBreaksCalculation() {
    const { totalTimeInSeconds } = this.state;
    const self = this;
    this.totalTimeInSeconds = this.state.totalTimeInSeconds === 0 ? this.player.getDuration() : totalTimeInSeconds;

    this.adBreaksStartTimes.map(value => {
      const adMarginInPercentage = (value / self.totalTimeInSeconds) * 100;
      this.adMargin.push(Number(adMarginInPercentage.toFixed(1)));
    });
  }

  async checkAndCallAdTracker() {
    this.filterAdData = [];
    this.adBreaksStartTimes = [];
    this.adBreaksEndTimes = [];
    const response = await requestAdGetCall(this.trackingHostUrl);
    this.filterAdData = await parseTrackerCallData(response);
    const self = this;
    this.adSeekTime = 0;
    clearInterval(this.adTimeInterval);
    this.isPlayBackStart = true;
    this.adDuration = "00:00";
    this.filterAdData.map(function(breaks, index) {
      self.adBreaksStartTimes.push(parseFloat(breaks.adBreakStartTime.toFixed(2)));
      self.adBreaksEndTimes.push(parseFloat((breaks.adBreakStartTime + breaks.totalAdBreakDuration).toFixed(2)));
    });

    this.adBreaksIndexes = this.adBreaksStartTimes.map((_, index) => index);

    if (this.config.playbackTime !== 0) {
      this.filterAdData.length !== 0 && (await this.adSeeker());
    }

    this.adBreaksCalculation();

    if (
      !this.props.videoData.isLive &&
      this.props.videoData.isWatchNow &&
      this.config.playbackTime > 0 &&
      this.filterAdData.length !== 0 &&
      this.isPlayfromStartCW === false
    ) {
      await this.seekOnAdCW();
    }
  }

  async adUIHandlerOnTimeChange() {
    let self = this;
    if (!this.props.videoData.isLive) {
      this.totalAdsInAdBreak = this.filterAdData[
        this.isForcedAd ? (this.isForcedAdFomCW ? 0 : this.isForcedAdIndex) : this.adBreakCounter
      ].totalAds;
      let startTime = parseFloat(
        this.adBreaksStartTimes[
          this.isForcedAd ? (this.isForcedAdFomCW ? 0 : this.isForcedAdIndex) : this.adBreakCounter
        ].toFixed(2)
      );
      let endTime = parseFloat(
        this.adBreaksEndTimes[
          this.isForcedAd ? (this.isForcedAdFomCW ? 0 : this.isForcedAdIndex) : this.adBreakCounter
        ].toFixed(2)
      );
      let currentTime = parseFloat(this.player.getCurrentTime().toFixed(2));
      let ads = this.filterAdData[
        this.isForcedAd ? (this.isForcedAdFomCW ? 0 : this.isForcedAdIndex) : this.adBreakCounter
      ].ads;
      if (currentTime >= startTime && currentTime < endTime) {
        this.isAdUIShown = true;
        this.isAdbreakFinish = true;
        if (this.adCounter < this.totalAdsInAdBreak) {
          if (!this.adTimeInterval) {
            this.currentAdData = ads[this.adCounter];
            this.adDurationSetTimeInterval = ads[this.adCounter].adDuration;
            this.adDurationinSeconds = ads[this.adCounter].adDuration;

            this.adTimeInterval = setInterval(function() {
              // smooth progress Bar set to 100MS
              if (self.isAdStalled === false) {
                self.adSeekTime += 0.1;
                self.adDurationSetTimeInterval -= 0.1;
                self.adDurationSetTimeInterval =
                  self.adDurationSetTimeInterval < 0 ? 0 : self.adDurationSetTimeInterval;

                self.adDuration = self.toMinutesAndSeconds(self.adDurationSetTimeInterval);
                if (self.adDurationSetTimeInterval <= 0) {
                  self.adSeekTime = 0;
                  self.currentAdData = null;
                  self.isAdStarted = true;
                  self.adCounter++;
                  clearInterval(self.adTimeInterval);
                  self.adTimeInterval = null;
                }
              }
            }, 100);
          }
          if (currentTime === parseInt(self.currentAdData.adStartTime) && self.isAdStarted) {
            self.isAdStarted = false;
          }
        } else {
          // for Ad
          this.adDuration = "00:00";
          if (this.adBreaksStartTimes.length === 1) {
            this.adCounter = 0;
          }
          this.isPlayBackStart = false;
          // this.adDurationinSeconds = 0;
          this.adDurationSetTimeInterval = 0;
          clearInterval(this.adTimeInterval);
          this.adTimeInterval = null;
        }
      } else {
        // for Ad break
        this.isAdUIShown = false;
        if (
          currentTime >= endTime &&
          (this.isForcedAd ? (this.isForcedAdFomCW ? 0 : this.isForcedAdIndex) : this.adBreakCounter) <
            this.adBreaksEndTimes.length
        ) {
          if (this.isAdbreakFinish === true) {
            if (this.isForcedAd) {
              this.player.seek(this.storedSeekedTime);
              if (this.isForcedAdFomCW) {
                this.adBreakCounter = await this.getNextAdIndex(this.storedSeekedTime, this.adBreaksStartTimes);
              } else {
                this.adBreaksIndexes = this.adBreaksIndexes.filter(number => number !== this.isForcedAdIndex);
                this.adBreakCounter = this.isForcedAdIndex + 1;
              }
              this.isForcedAd = false;
              this.isForcedAdFomCW = false;
              this.isPlayfromStartCW = false;
              if (this.adBreakCounter === this.adBreaksEndTimes.length) {
                this.adBreakCounter = this.adBreaksEndTimes.length - 1;
              }
            } else {
              this.adBreaksIndexes = this.adBreaksIndexes.filter(number => number !== this.adBreakCounter);
              this.adBreakCounter++;
              if (this.adBreakCounter === this.adBreaksEndTimes.length) {
                this.adBreakCounter = this.adBreaksEndTimes.length - 1;
              }
            }
            this.resetAdbreak();
            this.loadPreferredSubtitletracks();
            this.loadPreferredAudiotracks();
          }
        }
      }
    } else {
      // if live content only preroll ads
      this.totalAdsInAdBreak = this.filterAdData[0].totalAds;
      let ads = this.filterAdData[0].ads;
      if (this.isPlayBackStart && this.adCounter < this.totalAdsInAdBreak) {
        this.isAdUIShown = true;
        if (!this.adTimeInterval) {
          this.currentAdData = ads[this.adCounter];
          this.adDurationSetTimeInterval = ads[this.adCounter].adDuration;
          this.adDurationinSeconds = ads[this.adCounter].adDuration;

          this.adTimeInterval = setInterval(function() {
            // smooth progress Bar set to 100MS
            if (self.isAdStalled === false) {
              self.adSeekTime += 0.1;
              self.adDurationSetTimeInterval -= 0.1;
              self.adDurationSetTimeInterval = self.adDurationSetTimeInterval < 0 ? 0 : self.adDurationSetTimeInterval;
              self.adDuration = self.toMinutesAndSeconds(self.adDurationSetTimeInterval);
              if (self.adDurationSetTimeInterval <= 0) {
                self.adSeekTime = 0;
                self.adCounter++;
                self.isAdStarted = true;
                self.currentAdData = null;
                clearInterval(self.adTimeInterval);
                self.adTimeInterval = null;
              }
            }
          }, 100);
        }
        if (self.isAdStarted) {
          self.isAdStarted = false;
        }
      } else {
        this.adCounter = 0;
        this.isAdUIShown = false;
        this.isPlayBackStart = false;
        clearInterval(this.adTimeInterval);
        this.adTimeInterval = null;
      }
    }
  }

  async checkConcurrency() {
    const { isAllowPlayback, concurrency } = await getConcurrency.call(this, this.props.videoData.subscription[0]);
    this.isAllowPlayback = isAllowPlayback;
    this.concurrency = concurrency;
  }
  getSumOfAllPackages(packages) {
    let totalSum = 0;
    const addonContent = this.props.videoData.subscription[0];
    const { subscriptions } = this.props.applicationState;
    const parentAddOnContent = getSuperParentAddOnNameForConcurrency(subscriptions, addonContent);
    let addonContentChildren = [];
    if (parentAddOnContent) {
      addonContentChildren =
        subscriptions?.find(sub => sub.name === parentAddOnContent)?.configuration?.subscriptionIncludes?.split(",") ||
        [];
    } else {
      addonContentChildren = [makeBaseContentAsStarzplay(addonContent)]; // starz has no parent so it will land in else case the we need to convert starz back to starzplay to check the concurrency count for it
    }
    totalSum = packages?.reduce((sum, pkg) => {
      return addonContentChildren.includes(pkg.package) ? sum + pkg.count : sum;
    }, 0);
    return totalSum;
  }

  extractDomainFromManifestUrl(url = "") {
    const parsedUrl = new URL(url);
    return parsedUrl.hostname;
  }

  async getNonDrmToken(url) {
    // Define a retry wrapper that will attempt to fetch the No DRM playback token.
    const fetchNoDRMWithRetry = async (retryCount = 0, maxRetries = 1) => {
      try {
        const currentProfile = await getCurrentProfile();
        const noDRMReqBody = {
          globalUserId: currentProfile?.profileId,
          releasePids: this.config?.dash_widevine_Without_ads?.pid || ["noFd3g7vuDHY"],
          protectionScheme: config.get().player.drmTechnology,
          country: getAppState().country,
          hostName: this.extractDomainFromManifestUrl(url),
          HASH_KEY: getSignatureKeyV1()
        };
        playbackTokenNonDRM = await sdk.authenticationManager.getPlaybackTokenNoDRM(noDRMReqBody);
      } catch (e) {
        // Retry for transient errors (not 4xx client errors)
        if (![400, 422, 406, 499].includes(e?.code) && retryCount < maxRetries) {
          return await fetchNoDRMWithRetry(retryCount + 1, maxRetries);
        }
        let httpError = {
          REQUEST: e?.url,
          RESPONSE: e?.code
        };

        let error = {
          code: NODRM_CALL_ERROR_CODE,
          data: { name: e.message }
        };

        setTimeout(() => {
          this.setState({ nextPlayBackShade: false }, () => {
            this.props.onChange({
              isError: true,
              colIndex: this.props.currentCol,
              rowIndex: this.props.currentRow,
              categoryIndex: this.props.currentCat
            });
          });
        }, 10);
        // Stop player manager and surface the error
        sdk.playerManager.willStop();
        this.playerErrorHandler(error, null, false, httpError);
        return false;
      }
    };
    await fetchNoDRMWithRetry();
  }

  async loadSource(playerConfig, streamingUrl) {
    this.player = new Player(document.getElementById("av-player-mini"), playerConfig);
    this.props.stateActions.setPlayer(this.player);
    this.props.stateActions.setPlayerConfig(this.config);
    if (this.config.contentType !== "AVOD") {
      this.checkConcurrency();
      const isConcurrencyFlow = await isInitiateConcurrencyFlow(this.props.videoData.subscription[0]);
      if (isConcurrencyFlow) {
        const userid = isGuestUserLoggedIn() ? getGuestUserID() : localStorage.getItem("globalUserId");
        sdk.mediaManager.concurrencyCheck(userid).then(concurrencyConfig => {
          this.setState({ totalPackageCount: this.getSumOfAllPackages(concurrencyConfig.packages) });
        });
      }
    }

    // in case of non protected and protected non drm dont send tokens and call LA url
    const isNotDRMFreeOrToken = ![DPLAY.free, DPLAY.token].includes(this.props.videoData.dPlay);
    const isNonTrailor = ["movie"].includes(this.props.videoData.videoType);

    if (isNonTrailor && isNotDRMFreeOrToken) {
      // Define a retry wrapper that will attempt to fetch the DRM playback token.
      const fetchDRMWithRetry = async (retryCount = 0, maxRetries = 1) => {
        const currentProfile = await getCurrentProfile();
        const DRMReqBody = {
          globalUserId: currentProfile?.profileId,
          releasePids: this.props.videoData.releasePid,
          protectionScheme: config.get().player.drmTechnology,
          country: getAppState().country,
          HASH_KEY: getSignatureKeyV1()
        };
        try {
          playbackToken = await sdk.authenticationManager.getPlaybackTokenV3(DRMReqBody);
        } catch (e) {
          // Retry for transient errors (not 4xx client errors)
          if (![400, 422, 406, 499].includes(e?.code) && retryCount < maxRetries) {
            return await fetchDRMWithRetry(retryCount + 1, maxRetries);
          }

          await this.props.stateActions.setForceLogout(e);
          // if Force logout show the popup
          if (!!getAppState().forceLogout) {
            this.props.resumeNavigation();
            await showForceLogoutError.call(this);
            return;
          }

          // used to send to splunk
          // The error code system is design to work on all types of errors
          //  error for this  is specific for this call
          //  cannot change orignal implementation
          let httpError = {
            REQUEST: e?.url,
            RESPONSE: e?.code
          };

          // used to view on screen
          let error = {
            code: VAULTO_CALL_ERROR_CODE, // network error
            data: {
              name: e.message
            }
          };

          sdk.playerManager.willStop();
          this.playerErrorHandler(error, null, true, httpError);
          return;
        }
      };
      // Invoke the DRM fetch before building the source so playbackToken is available
      await fetchDRMWithRetry();
    }

    const widevineURL =
      (await getWidevineURL(getAppState().widevineConfig, getAppState().country)) ||
      "https://widevine-license.vudrm.tech/proxy";
    // this is used to replace the current mena urls to https starz play url . need something to remove hardcoded
    streamingUrl = streamingUrl
      .replace(/http\:\/\/mena-jit-cdn-lb.aws.playco.com/, "https://mena-jit-cdn-lb.aws.playco.com")
      .replace(/https?:\/\/starzplay-jit-prod-ssl.akamaized.net/, "https://mena-jit-cdn-lb.aws.playco.com");

    const source = {
      dash: streamingUrl,
      options: {
        startOffset: this.config.playbackTime !== 0 ? this.config.playbackTime : 0
      },
      ...(isNotDRMFreeOrToken && {
        // Include DRM only if dPlay is not "free" or "token"
        drm: {
          widevine: {
            LA_URL: widevineURL,
            prepareMessage(keyMessage) {
              return JSON.stringify({
                token: playbackToken,
                drm_info: Array.apply(null, new Uint8Array(keyMessage.message))
              });
            }
          }
        }
      }),
      events: {
        [PlayerEvent.Error]: this.playerErrorEventHandler
      }
    };
    Logger.log("On Init event callback function is going to run. Is mounted:TRUE", "Player.onInit");
    Logger.log("Initializing player load timer", "Player.onInit");
    setPlayerLoadTimer.call(this);
    this.player
      .load(source)
      .then(() => {
        const subtitleUI = new UIContainer({
          components: [new SubtitleOverlay(), new SeekBar()]
        });

        this.player.on(PlayerEvent.Ready, this.readyEventHandlerTimeout);
        this.player.on(PlayerEvent.Seek, this.seekEventHandler);
        destroyPlayerLoadTimer.call(this);

        // Launch the UI
        const uiManager = new UIManager(this.player, subtitleUI);
        this.player.play();
        !this.props.videoData.isLive && this.getFilmStrip();
        this.loadSubtitlesTracks();
        this.loadAudioTracks();
        this.loadPreferredSubtitletracks();
        this.loadPreferredAudiotracks();
        // start playing event bitmovin
        // this.con
        this.player.on(PlayerEvent.Playing, this.playEventHandler);

        // playback finished event bitmovin
        this.player.on(PlayerEvent.PlaybackFinished, this.playbackFinishedEventHandler);

        // time update event bitmovin
        this.player.on(PlayerEvent.TimeChanged, this.timeChangedEventHandler);

        // segment playback bitmovin
        this.player.on(PlayerEvent.SegmentPlayback, this.segmentPlaybackEventHandler);
      })
      .catch(e => {
        Logger.log(
          `Requesting error message for error: ${e} after failure in bitmovin player config`,
          "Player.loadSource"
        );
        destroyPlayerLoadTimer.call(this);
      });

    this.player.on(PlayerEvent.Error, this.playerErrorEventHandler);
    this.player.on(PlayerEvent.StallStarted, this.stallStartedEventHandler);
    this.player.on(PlayerEvent.StallEnded, this.stallEndedEventHandler);

    ///////////////// start : Analytics Youbora ///////////////
    const { playbackAnalytics } = config.get().featureToggles;
    !!playbackAnalytics && (await sdk.playerManager.startPlaybackAnalytics(this.config));
    ///////////////// end : Analytics Youbora ///////////////
  }
  /**
   * After turning off the player load timer to avoid doubling errors, checks if any error code is received to get
   * its customized error message to show in a modal and sends an error report.
   * @param {Object} error - Error data
   */

  stallStartedEventHandler = e => {
    this.setState(
      {
        playerBuffering: true,
        nextPlayBackShade: false
      },
      () => {
        this.props.onChange({
          playerBuffering: false,
          colIndex: this.props.currentCol,
          rowIndex: this.props.currentRow,
          categoryIndex: this.props.currentCat
        });
      }
    );
    this.isAdStalled = true;
    this.networkErrorTimeout = setTimeout(() => {
      this.playerErrorEventHandler({
        code: 1400
      });
    }, 10000);
  };
  stallEndedEventHandler = e => {
    this.setState(
      {
        playerBuffering: false,
        nextPlayBackShade: false
      },
      () => {
        this.props.onChange({
          playerBuffering: false,
          colIndex: this.props.currentCol,
          rowIndex: this.props.currentRow,
          categoryIndex: this.props.currentCat
        });
      }
    );
    this.isAdStalled = false;
    this.networkErrorTimeout && clearTimeout(this.networkErrorTimeout);
  };
  playerErrorHandler(error, bitmovinEvent = null, istokenCallFails = false, httpError = null) {
    if (error && error.data) {
      const { sendReport = true } = error;
      try {
        Logger.log(`Player emitted an error ${error.code} with data: ${error.data.name}`, "Player.playerErrorHandler");
        destroyPlayerLoadTimer.call(this, false);
        Logger.log(`Requesting error message for error: ${error && error.code}`, "Player.playerErrorHandler");
        const message = error.code && getPlayerErrorMessage(error.code);
        const messageHeading = error.code && getPlayerErrorMessageHeading(error.code);
        sendReport && sendPlayerErrorReport.call(this, error, message, bitmovinEvent, istokenCallFails, httpError);
        this.didErrorHappen = true;
        // Next state checking is due to double errors that might come from sdk, such as related with DRM.
        if (istokenCallFails === true) {
          this.props.onChange({
            isError: true,
            colIndex: this.props.currentCol,
            rowIndex: this.props.currentRow,
            categoryIndex: this.props.currentCat
          });
        }
        // !this.state.errorMessage && this.showErrorModal(message, messageHeading);
      } catch (error) {
        Logger.log(`Requesting error message for error: ${error && error.code}`, "Player.playerErrorHandler");
        const message = getPlayerErrorMessage(error.code);
        this.showErrorModal(message);
      }
      sdk.playerManager.destroy();
    } else {
      Logger.log(`Player ignored an error ${error.code} with data: ${error.data.name}`, "Player.playerErrorHandler");
    }
  }

  static getPlayerLog(player) {
    const { playbackState, activePanel, currentTime, playerBuffering, duration, currentTimeInSeconds } = player;

    return {
      playbackState,
      activePanel,
      currentTime,
      playerBuffering,
      duration,
      currentTimeInSeconds
    };
  }

  showErrorModal(message, errorMessageHeading = null) {
    this.setState({ errorMessage: message, errorMessageHeading });
  }

  checkTimeForSendEvent() {
    const { isLive, moduleId } = this.props.videoData;
    if (this.state.currentTimeInSeconds !== this.previousSecond) {
      this.calculateTimes();
      const foundPlaybackTime = this.getPlaybackTimePercentIndex(this.state.currentTimeInSeconds);
      if (!isLive && this.playbackTimes.length > 0 && foundPlaybackTime > -1) {
        sendUserEvent({
          module_id: moduleId,
          id: this.config.id,
          action: "watch",
          value: this.playbackPercentages[foundPlaybackTime]
        });
        this.playbackPercentages.splice(0, foundPlaybackTime + 1);
      }
      this.previousSecond = this.state.currentTimeInSeconds;
    }
  }
  checkPercentageTimePlayed() {
    const { isLive, moduleId, videoType } = this.props.videoData;
    !isLive &&
      sendUserEvent({
        module_id: moduleId,
        id: this.config.id,
        action: "stop",
        value: this.getPercentPlayed(),
        eventType: "watch"
      });
  }

  /**
   * Returns the percent played with two decimals
   * @returns {Number}
   */
  getPercentPlayed() {
    const percent = this.state.currentTimeInSeconds / this.state.totalTimeInSeconds;
    return percent.toFixed(2);
  }

  calculateTimes() {
    if (this.state.totalTimeInSeconds) {
      this.playbackTimes = this.playbackPercentages.map(percentage => {
        return Math.floor(this.state.totalTimeInSeconds * percentage);
      });
    }
  }

  /**
   * Looks if the current percentage time played is in the percentages array.
   * This array (this.playbackTimes) has the percentages in which the user event will be sent.
   * @param {Number} currentTimeInSeconds
   * @returns {Number} Returns 0 if the index of the percent playing is in array or -1 if not
   */
  getPlaybackTimePercentIndex(currentTimeInSeconds) {
    const playbackTimeIndex = this.playbackTimes.findIndex(item => item > currentTimeInSeconds);

    if (this.playbackTimes.length > 1) {
      return playbackTimeIndex - 1;
    } else if (this.playbackTimes.length === 1) {
      return this.playbackTimes[0] < currentTimeInSeconds ? 0 : -1;
    }
    return -1;
  }

  bindings() {
    this.shouldRenderPlaybackRate = this.shouldRenderPlaybackRate.bind(this);
    this.selectTrack = this.selectTrack.bind(this);
    this.getTimeMarkers = this.getTimeMarkers.bind(this);
    this.handleRemoteKeys = this.handleRemoteKeys.bind(this);
    this.handleRemoteKeysFilmstrip = this.handleRemoteKeysFilmstrip.bind(this);
    this.showProgressBar = this.showProgressBar.bind(this);
    this.showBar = this.showBar.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
  }

  backHandler() {
    this.setState(
      {
        selectBtn: 0
      },
      () => {
        this.props.onChange({
          onFullScreen: true,
          buttonEnter: BUTTONS_LABELS[1],
          isBack: true,
          colIndex: this.props.currentCol,
          rowIndex: this.props.currentRow,
          categoryIndex: this.props.currentCat
        });
      }
    );
  }

  /**
   * Callback for the skip ad if enabled
   */

  clearUserMediaCached() {
    this.props.applicationState.userMediaCached = null;
  }

  /**
   * Returns time markers from server
   * @returns {Object}
   */
  async getTimeMarkers(mediaGuid) {
    const { country } = this.props.applicationState;
    return (await sdk.mediaManager.getTitleTimeMarkers({ mediaGuid, country })) || {};
  }

  async togglePausePlay() {
    const { wheelState } = this.props;
    const isSVODUser = getAppState()?.isSvodUser;
    const isShowAds = !isSVODUser ? true : this.props.videoData?.enforceAds && isSVODUser ? true : false;
    if (this.props.applicationState.currentFocus === PAUSE_AD_BUTTON_FOCUS && wheelState !== "active") {
      this.pauseAdHandler();
      return;
    }
    if (this.props.applicationState.currentFocus === CLOSE_BUTTON_FOCUS && wheelState !== "active") {
      this.closeModal(PAUSE_AD_BUTTON_FOCUS);
      return;
    }
    if (this.state.selectBtn === -1) return;
    if (!this.props.videoData.isLive) {
      if (!this.state.isSeeked) {
        if (this.state.isPlaying === false) {
          this.setState(
            {
              isPlaying: true,
              selectBtn: 0,
              showFilmStrip: false,
              openTracksAndAudio: false
            },
            () => {
              if (this.props.isFullScreen) this.props.actions.pauseNavigation();
            }
          );
          // Adtech Project - Clear Pause Ad States - Start
          isShowAds && (await this.addTeckApiCallPlusStateUpdate(true));
          // Adtech Project - Clear Pause Ad States - End
          this.player.play();
          clearInterval(this.showPauseScreenInterval);
          this.setState({
            showPauseScreen: false
          });
          this.showControls();
        } else {
          isShowAds && (await this.addTeckApiCallPlusStateUpdate());
          this.setState(
            {
              isPlaying: false,
              selectBtn: 0,
              showFilmStrip: false,
              openTracksAndAudio: false
            },
            () => {
              if (this.props.isFullScreen) this.props.actions.pauseNavigation();
            }
          );
          this.player.pause();
          sdk.playerManager.pause();
          // Adtech Project - Setting Focus and Send Impressions - Start
          if (this.state.pauseAd) {
            this.props.setFocus(PAUSE_AD_FOCUS);
            changeState.call(this, playerUiStates.PAUSE);
            await impressionTracking(this.state.pauseAd?.impressionTrackingURL);
          }
          // Adtech Project - Setting Focus and Send Impressions - End
          this.showPauseScreenInterval = setInterval(() => {
            this.setState({
              showPauseScreen: true
            });
          }, this.timeToShowPauseScreen);
          this.showControls();
        }
      } else {
        const playState = this.state.isPlaying;
        const self = this;
        playState ? this.player.pause() : this.player.play();
        this.setState({ isPlaying: !playState });
        if (this.state.showFilmStrip) {
          this.player.pause();
          const isLandOnAdbreak = await this.findTimeIndex(
            this.state.seekedTime,
            this.adBreaksStartTimes,
            this.adBreaksEndTimes
          );
          if (this.isForcedAd) {
            isLandOnAdbreak !== -1 ? (this.isForcedAd = false) : (this.isForcedAd = true);
            this.storedSeekedTime = this.state.seekedTime;
          }
          this.player.seek(isLandOnAdbreak !== -1 ? this.adBreaksEndTimes[isLandOnAdbreak] : this.state.seekedTime);

          if (this.isForcedAd) {
            setTimeout(function() {
              let startTime = self.adBreaksStartTimes[self.isForcedAdIndex];
              self.player.seek(startTime - STUFFSKIPAD);
            }, DELAY_TIMEOUT);
          }
        }
      }
    }
  }

  async addTeckApiCallPlusStateUpdate(clearPauseAdState = false) {
    if (clearPauseAdState) {
      if (this.state.pauseAd) {
        this.setState({
          pauseAd: null
        });
      }
      return;
    }
    const pauseAd = await this.getFullScreenAd();
    if (pauseAd) {
      this.setState({
        pauseAd
      });
    }
  }

  // Adtech Project - Getting Full Screen Ad - Start
  async getFullScreenAd() {
    const { id, videoType, title, seriesTitle, assetTypes, genres } = this.props.videoData;
    const { showPauseAds } = this.props.applicationState;
    let pauseAd = null;

    if (showPauseAds) {
      this.setState({ playerBuffering: true });
      pauseAd = await getPauseAd({
        isLiveContent: true,
        id,
        title: videoType === "series" || videoType === "episode" ? seriesTitle : title,
        assetTypes,
        genres
      });
    }
    this.setState({ playerBuffering: false });
    return pauseAd;
  }
  // Adtech Project - Getting Full Screen Ad - End

  pausedSeek() {
    this.setState({
      isPlaying: false
    });
    this.player.pause();
    sdk.playerManager.pause();
  }

  seekLeft() {
    //10 seconds back
    this.playbackIconName = "rewind";
    if (this.state.isPlaying === true) {
      this.pausedSeek();
    }
    if (this.state.seekedTime > 0) {
      this.setState({
        showFilmStrip: true,
        seekedTime: this.state.seekedTime - 10,
        isSeeked: true
      });
      this.filterAdData.length !== 0 && this.adSeeker(false);
      // time should updated in view instant when seek left is pressed
      let time = this.toMinutesAndSeconds(this.state.seekedTime);
      this.setState({
        currentTime: time
      });

      if (!this.state.filmstripData) {
        // this.getFilmStrip();
      } else {
        onStateEnter[playerUiStates.FILMSTRIP].call(this);
      }
    }
  }
  seekRight(defaultSeekTime = 10) {
    this.playbackIconName = "forward";
    // 10 seconds forward
    if (this.state.isPlaying === true) {
      this.pausedSeek();
    }
    if (this.state.seekedTime + defaultSeekTime <= this.player.getDuration() - defaultSeekTime) {
      this.setState({
        showFilmStrip: true,
        seekedTime: this.state.seekedTime + defaultSeekTime,
        isSeeked: true
      });

      this.filterAdData.length !== 0 && this.adSeeker(true);

      // time should updated in view instant when seek right is pressed
      let time = this.toMinutesAndSeconds(this.state.seekedTime);
      this.setState({
        currentTime: time
      });

      if (!this.state.filmstripData) {
        // this.getFilmStrip();
      } else {
        onStateEnter[playerUiStates.FILMSTRIP].call(this);
      }
    }
  }

  async getAdBreakIndex(seekedTime, starts, ends) {
    for (let i = 0; i < starts.length; i++) {
      if (seekedTime >= starts[0] && seekedTime <= starts[1]) {
        return 0;
      } else if (seekedTime >= starts[i] && seekedTime <= ends[i]) {
        return i;
      }
    }
    return -1;
  }

  async findTimeIndex(currentTime, startTimes, endTimes) {
    for (let i = 0; i < startTimes.length; i++) {
      if (currentTime >= startTimes[i] && currentTime <= endTimes[i]) {
        return i;
      }
    }
    return -1;
  }

  async isCurrentAndSeekTimeAtSameInterval(startTimeArray, currentTime, seekTime) {
    let currentTimeInterval = null;
    let seekTimeInterval = null;
    let areIntervalsSame = false;

    // Check if currentTime or seekTime is greater than the last time in the array
    const lastTime = startTimeArray[startTimeArray.length - 1];
    if (currentTime > lastTime) {
      currentTimeInterval = [lastTime, Infinity]; // Use Infinity to indicate "beyond the last interval"
    }
    if (seekTime > lastTime) {
      seekTimeInterval = [lastTime, Infinity]; // Same for seekTime
    }

    for (let i = 0; i < startTimeArray.length - 1; i++) {
      if (currentTime > startTimeArray[i] && currentTime < startTimeArray[i + 1]) {
        currentTimeInterval = [startTimeArray[i], startTimeArray[i + 1]];
      }
      if (seekTime > startTimeArray[i] && seekTime < startTimeArray[i + 1]) {
        seekTimeInterval = [startTimeArray[i], startTimeArray[i + 1]];
      }
    }

    // If both intervals have been found, compare them
    if (currentTimeInterval && seekTimeInterval) {
      areIntervalsSame =
        currentTimeInterval[0] === seekTimeInterval[0] && currentTimeInterval[1] === seekTimeInterval[1];
    }

    return areIntervalsSame;
  }

  async adSeeker(isNotRewind) {
    if (this.isAdexists()) {
      let seekedTime = this.state.seekedTime;
      const isSameInterval = await this.isCurrentAndSeekTimeAtSameInterval(
        this.adBreaksStartTimes,
        this.player.getCurrentTime(),
        seekedTime
      );
      if (!isSameInterval) {
        if (isNotRewind) {
          const adBreakIndex = await this.getAdBreakIndex(seekedTime, this.adBreaksStartTimes, this.adBreaksEndTimes);
          if (adBreakIndex !== -1) {
            const isAdBreakNumberExits = this.adBreaksIndexes.includes(adBreakIndex);
            if (isAdBreakNumberExits) {
              this.isForcedAdIndex = adBreakIndex;
              localStorage.setItem("adbreakexitindex", adBreakIndex);
              this.isForcedAd = true;
            } else {
              this.adBreakCounter = await this.getNextAdIndex(seekedTime, this.adBreaksStartTimes);
              if (this.adBreakCounter === -1) this.adBreakCounter = 0;
              this.isForcedAd = false;
            }
          }
        } else if (!isNotRewind) {
          this.adBreakCounter = await this.getNextAdIndex(seekedTime, this.adBreaksStartTimes);
          if (this.adBreakCounter === -1) this.adBreakCounter = 0;
          this.isForcedAd = false;
        }
      } else if (isSameInterval) {
        const isAdBreakNumberExits = this.adBreaksIndexes.includes(parseInt(localStorage.getItem("adbreakexitindex")));
        localStorage.removeItem("adbreakexitindex");
        if (isAdBreakNumberExits) {
          this.isForcedAd = true;
        }
      }
    }
  }

  async reloadWait(ms) {
    return new Promise(resolve => (this.clearRefreshTimeout = setTimeout(resolve, ms)));
  }
  async seekOnAdCW() {
    await this.reloadWait(1000); // delay 1 sec
    let seekedTime = this.player.getCurrentTime(); //this.state.seekedTime;
    const isLandOnAdbreak = await this.findTimeIndex(seekedTime, this.adBreaksStartTimes, this.adBreaksEndTimes);
    if (isLandOnAdbreak !== -1) {
      seekedTime = this.adBreaksEndTimes[isLandOnAdbreak];
    }
    const findNextAdIndex = await this.getNextAdIndex(seekedTime, this.adBreaksStartTimes);
    this.storedSeekedTime = seekedTime;
    this.isForcedAdIndex = findNextAdIndex;
    this.isForcedAdFomCW = true;
    this.isForcedAd = true;
    this.adBreaksIndexes = this.adBreaksIndexes.filter(number => number !== 0); // remove 0th pre roll ad from list
    this.player.seek(0);
  }

  async getNextAdIndex(seekTime, startTimes) {
    let lowerIndex = -1;
    let upperIndex = -1;
    for (let i = 0; i < startTimes.length - 1; i++) {
      const current = startTimes[i];
      const next = startTimes[i + 1];

      if ((seekTime > current && seekTime < next) || (seekTime < current && seekTime > next)) {
        lowerIndex = i;
        upperIndex = i + 1;
        break; // Exit loop once we find the pair
      }
    }
    return seekTime > startTimes[startTimes.length - 1] ? startTimes.length - 1 : upperIndex;
  }

  playerErrorEventHandler = event => {
    let errorCode = getErrorCode(event.code);
    let error = {
      code: errorCode,
      data: {
        name: event.name
      }
    };

    if (errorCode === DISCONNECTIVIITY_INTERNET_ERROR_CODE) {
      this.player.pause();
    }

    this.setState({ nextPlayBackShade: false }, () => {
      this.props.onChange({
        isError: true,
        colIndex: this.props.currentCol,
        rowIndex: this.props.currentRow,
        categoryIndex: this.props.currentCat
      });
    });

    this.playerErrorHandler(error, event);
  };

  playFromStartSeekedEventHandler = event => {
    this.setState({
      currentTime: "00:00",
      isSeeked: false
    });
    this.player.play();
    sdk.playerManager.seek();
  };

  readyEventHandlerTimeout = async () => {
    sdk.playerManager.ready();

    Logger.log("Tizen Bitmovin player Ready", "Player.Ready");
    this.setState(
      {
        currentTime: this.toMinutesAndSeconds(this.config.playbackTime !== 0 ? this.config.playbackTime : 0)
      },
      this.setState({
        isPlayerLoaded: true,
        playbackState: "init"
      })
    );
    if (this.isAdexists() && (!Array.isArray(this.filterAdData) || !this.filterAdData.length)) {
      this.checkAndCallAdTracker();
    }

    await setHeartBeatTimer(this.props.videoData?.contentType);
    sdk.playerManager.stop(false);
    sdk.playerManager.configSuccess(this.config);
  };

  seekEventHandler = e => {
    sdk.playerManager.setCurrentTime(e.seekTarget * 1000);
    clearInterval(this.showPauseScreenInterval);
    clearTimeout(this.showHidePlayerControls);

    if (!this.props.videoData.isLive) {
      sdk.playerManager.seek();
      this.setState({
        seekedTime: e.seekTarget,
        currentTime: this.toMinutesAndSeconds(e.seekTarget)
      });

      this.player.on(PlayerEvent.Seeked, this.seekedHandler);

      this.setState({ playerBuffering: true }, () => {
        this.player.pause();
        this.props.onChange({
          playerBuffering: false,
          colIndex: this.props.currentCol,
          rowIndex: this.props.currentRow,
          categoryIndex: this.props.currentCat
        });
      });
    }
  };

  seekedHandler = e => {
    const playState = this.state.isPlaying;
    if (playState) {
      sdk.playerManager.play();
      this.setState({ playerBuffering: false, isSeeked: false, showFilmStrip: false }, () => {
        this.player.play();
      });
    } else {
      sdk.playerManager.pause();
      this.setState({ playerBuffering: false, isSeeked: false, showFilmStrip: false }, () => {
        this.player.pause();
      });
    }
  };

  playEventHandler = event => {
    let time = this.toMinutesAndSeconds(this.player.getDuration());
    this.showControls();
    Logger.log("this.mounted value is:true", "Player.onPlay");
    if (this.props.playFromStart && this.props.isFullScreen && !this.isStartOver) this.playFromBeginning();
    this.isAdStalled = false;
    this.isStartOver = true;
    this.setState({
      duration: time,
      playerBuffering: false,
      playbackState: "play",
      totalTimeInSeconds: this.player.getDuration(),
      nextPlayBackShade: false
    });
    getAppState().playbackStartTime = new Date().getTime();
    sdk.playerManager.play();
  };

  segmentPlaybackEventHandler = data => {};

  timeChangedEventHandler = event => {
    // concurrency error check
    if (
      this.state.totalPackageCount >= this.concurrency &&
      !this.isAllowPlayback &&
      this.config.contentType !== "AVOD"
    ) {
      let error = {
        code: "571140",
        data: {
          name: "concurrency"
        }
      };
      this.setState({ nextPlayBackShade: false }, () => {
        this.props.onChange({
          isError: true,
          errorHeading: i18n.get("pages.player.errorTitle.concurrencyErrorTitle"),
          errorMessage: i18n.get("pages.player.errors.concurrencyError"),
          colIndex: this.props.currentCol,
          rowIndex: this.props.currentRow,
          categoryIndex: this.props.currentCat
        });
      });
      this.player.pause();
      this.player.unload();
      this.playerErrorHandler(error);
    }

    this.setState({
      seekedTime: this.player.getCurrentTime()
    });
    let time = this.toMinutesAndSeconds(this.player.getCurrentTime());
    this.setState({
      currentTime: time,
      currentTimeInSeconds: this.player.getCurrentTime()
    });

    // send current time in milliseconds for heartbeat
    if (!this.state.showFilmStrip) {
      sdk.playerManager.setCurrentTime(this.player.getCurrentTime() * 1000);
    }
    this.state.totalTimeInSeconds && this.checkTimeForSendEvent();

    if (this.isAdexists() && this.filterAdData.length !== 0) {
      this.adUIHandlerOnTimeChange();
    }
  };

  playEventSeekedEventHandler = event => {
    this.player.play();
    this.setState({
      isTryToplayFromResume: false
    });
  };

  playbackFinishedEventHandler = async event => {
    // byte+ stay event
    sendStayEventForBytePlus({
      titleId: this.config?.id,
      seriesId: this.config?.id,
      subType: this.config?.contentType || this.props?.videoData?.contentType,
      mediaData: this.props?.videoData,
      currentScreen: sessionStorage.getItem("currentScreen"),
      previousScreen: sessionStorage.getItem("prevScreen"),
      playerCurrentTime: this.player ? this.player.getCurrentTime() : 0
    });
    if (
      this.config.channelType === CHANNEL_TYPES.playlist &&
      this.playlistCounter < this.props.videoData.playlist.length - 1
    ) {
      await this.updateNextPlaylistItem();
    } else {
      await this.backHandler();
    }
  };

  // Adtech Project - Pause Ad Button Action - Start
  pauseAdHandler() {
    const { pauseAd } = this.state;
    const titleURL = this.state.pauseAd?.destURL;
    const qrCodeURL = this.state.pauseAd?.clickTrackingURL;
    const isShowPauseAd = pauseAd ? true : false;
    this.props.toggleQRCodeModal(true);
    return showQRCodeModal.call(this, this.closeModal.bind(this), titleURL, qrCodeURL, isShowPauseAd);
  }
  // Adtech Project - Pause Ad Button Action - End

  playFromStart() {
    this.player.pause();
    this.setState(
      {
        seekedTime: 0
      },
      () => this.player.seek(this.state.seekedTime)
    );
    this.isPlayfromStartCW = true;
    this.playFromStartSeekedEventHandler();
    !this.props.videoData.isLive && this.resetAdsPlayFromStart();
  }

  resetAdsPlayFromStart() {
    clearInterval(this.adTimeInterval);
    this.currentAdData = null;
    this.isAdStarted = true;
    this.adBreakCounter = 0;
    this.adCounter = 0;
    this.adDuration = "00:00";
    this.totalAdsInAdBreak = 0;
    this.adDurationinSeconds = 0;
    this.adDurationSetTimeInterval = 0;
    this.isAdUIShown = false;
    this.isAdbreakFinish = false;
    this.adSeekTime = 0;
    this.adTimeInterval = null;
    this.seekedInAd = false;
  }

  getCurrentTimestamp() {
    return this.state.seekedTime * 1000 || 0;
  }

  shouldShowLoading() {
    return this.state.playerBuffering;
  }

  getFilmStrip() {
    sdk.mediaManager
      .getFilmstripData(this.props.videoData.filmstrip)
      .then(filmstripData => this.setState({ filmstripData }));
  }

  toMinutesAndSeconds(elapsedTime) {
    let hours = Math.trunc(elapsedTime / 60 / 60);
    elapsedTime -= hours * 60 * 60;
    let minutes = Math.trunc(elapsedTime / 60);
    let seconds = Math.trunc(elapsedTime % 60);
    if (seconds < 0) seconds = 0;
    if (hours === 0) {
      hours = "";
    } else if (hours < 10) {
      hours = `0${hours}:`;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return `${hours}${minutes}:${seconds}`;
  }

  shouldRenderPlaybackRate() {
    return this.state.showFilmStrip && (this.state.playbackRate > 0 || !this.hasThumbnails());
  }

  hasThumbnails() {
    return (
      this.state.filmstripData && this.state.filmstripData.thumbnails && !!this.state.filmstripData.thumbnails.length
    );
  }

  destroyPlayer() {
    if (this.player != null) {
      this.player.destroy();
      this.setState({
        ...this.state,
        player: null
      });
    }
  }

  closeModal(focusPath = defaultFocusPath) {
    this.props.stateActions.hideGlobalModal();
    this.props.setFocus(this.state.pauseAd ? PAUSE_AD_BUTTON_FOCUS : focusPath);
    this.props.toggleQRCodeModal(false);
  }

  doNothing() {}

  handleError = e => {
    e.target.src = this.appFlow !== RTL ? DefaultChannelImage : DefaultChannelImageLeft;
  };

  render() {
    const { videoType, isLive, backgroundCover } = this.props.videoData;
    const { isFullScreen, channelImage } = this.props;
    const imageStyle = { objectFit: "contain", width: "100%", height: "100%" };

    return !!this.state.errorMessage ? (
      isFullScreen !== true && <Text type={this.state.errorMessage}> </Text>
    ) : (
      <Wrapper onClick={isFullScreen ? this.showProgressBar.bind(this) : this.doNothing()}>
        {this.shouldShowLoading() && (
          <>
            <Loading overlay />
            {isFullScreen === false && (
              <img src={channelImage} style={imageStyle} alt="image missing" onError={this.handleError} />
            )}
          </>
        )}
        {!this.shouldShowLoading() && this.state.isPlayerLoaded && this.isAdUIShown && isFullScreen === false && (
          <LowerPlayerControlsAdsMiniPlayer className="smallplayer">
            <AdInfoStyleMiniPlayer direction={this.appFlow}>
              <AdTag text={`${"&nbsp" + i18n.get("pages.player.ad") + "&nbsp"}`} />
            </AdInfoStyleMiniPlayer>
          </LowerPlayerControlsAdsMiniPlayer>
        )}

        {this.state.nextPlayBackShade && isFullScreen === true && <NextPlayBackShade></NextPlayBackShade>}
        {!this.state.playerBuffering &&
        !this.state.isSeeked &&
        this.isAdUIShown === false &&
        isFullScreen === true &&
        this.state.isPlaying === false ? (
          this.state.pauseAd ? (
            <PauseAdScreen
              focusPath={PAUSE_AD_FOCUS}
              adImage={this.state.pauseAd?.imageURL}
              title={this.state.title && i18n.get("global.adTech.pauseAd.resumeCta", this.state.title)}
              thumbnail={backgroundCover}
              buttonFocusPath={PAUSE_AD_BUTTON_FOCUS}
              buttonLabel={this.state.pauseAd?.cta || i18n.get("global.adTech.pauseAd.visitCta")}
              isShowCta={!!this.state.pauseAd?.clickTrackingURL}
              adLabel={i18n.get("global.adTech.pauseAd.label")}
              adTagline={i18n.get("global.adTech.pauseAd.text")}
              adHandler={this.pauseAdHandler.bind(this)}
              playVideoHandler={this.togglePausePlay.bind(this)}
            />
          ) : (
            this.state.showPauseScreen && (
              <PauseScreen
                heading={i18n.get("pages.player.youAreWatching")}
                contentTitle={this.state.title}
                contentDescription={this.state.description}
              />
            )
          )
        ) : null}

        {!this.shouldShowLoading() &&
          this.state.openTracksAndAudio &&
          this.state.showPlayerControls &&
          this.isAdUIShown === false &&
          isFullScreen === true && (
            <Tracks
              audioTracks={this.state.audioTracks}
              subtitleTracks={this.state.subtitleTracks}
              audioTitle={i18n.get("pages.player.audio")}
              subtitlesTitle={i18n.get("global.subtitles")}
              onTrackSelected={this.selectTrack}
            />
          )}
        {!this.shouldShowLoading() &&
          this.state.showPlayerControls &&
          isFullScreen === true &&
          this.isAdUIShown === false && <Title className="zindex playerTitle" title={this.state.title} />}
        {!this.shouldShowLoading() &&
          this.shouldRenderPlaybackRate() &&
          isFullScreen === true &&
          this.isAdUIShown === false && (
            <PlaybackRate
              rate={this.state.playbackRate || undefined}
              iconName={this.playbackIconName || undefined}
              text={!this.hasThumbnails() ? i18n.get("pages.player.pressOkButtonToResume") : undefined}
            />
          )}
        {!this.shouldShowLoading() &&
          this.state.showFilmStrip === true &&
          this.isAdUIShown === false &&
          this.state.showPlayerControls &&
          this.state.filmstripData &&
          isFullScreen === true &&
          this.state.filmstripData.thumbnails &&
          this.state.filmstripData.thumbnails.length > 0 &&
          !isLive &&
          !this.state.playerBuffering && (
            <FilmstripFocus
              focusPath={"filmstrip"}
              thumbnails={this.state.filmstripData.thumbnails}
              initialThumbnail={
                this.state.filmstripData.thumbnails.length > this.state.currentFilmstripPosition &&
                this.state.currentFilmstripPosition
              }
              filmstripCarousel={carousel => (this.filmstrip = carousel)}
              direction={i18n.directions.LEFT_TO_RIGHT}
            />
          )}

        {!this.shouldShowLoading() &&
        this.state.isPlayerLoaded &&
        this.state.showPlayerControls &&
        !this.isAdUIShown ? (
          <PlayerShadow style={{ zIndex: 9 }}>
            {isFullScreen === true && (
              <ControlsSettingsStyled>
                <ControlSettingsBtn xmlns="http://www.w3.org/2000/svg" onClick={this.backHandler.bind(this)}>
                  <FillBtnBack className={this.state.selectBtn === 1 ? "activePlayer" : null} />
                </ControlSettingsBtn>
                {!this.state.playerBuffering && (
                  <ControlSettingsBtn xmlns="http://www.w3.org/2000/svg" onClick={this.openLanguage.bind(this)}>
                    <FillBtnLanguage className={this.state.selectBtn === 2 ? "activePlayer" : null} />
                  </ControlSettingsBtn>
                )}
                {!this.state.playerBuffering && !isLive && (
                  <ControlSettingsBtn xmlns="http://www.w3.org/2000/svg" onClick={this.playFromBeginning.bind(this)}>
                    <FillBtnStart className={this.state.selectBtn === 3 ? "activePlayer" : null} />
                  </ControlSettingsBtn>
                )}
              </ControlsSettingsStyled>
            )}
            {isFullScreen === true && (
              <LabelDiv
                style={
                  i18n.getDirection() === "ltr"
                    ? { marginLeft: this.state.margin + "em" }
                    : { marginRight: this.state.margin + "em" }
                }
              >
                {<LabelStyled>{this.state.textLabels[this.state.selectBtn]}</LabelStyled>}
              </LabelDiv>
            )}
            {this.state.showPauseScreen === false && isFullScreen === true && (
              <LowerPlayerControls
                dir="ltr"
                onMouseOver={this.showBar.bind(this)}
                onMouseOut={this.showControls.bind(this)}
              >
                {!isLive && (
                  <PlayPauseToggle id="playpause" onClick={this.togglePausePlay.bind(this)}>
                    <ToggleBtn xmlns="http://www.w3.org/2000/svg">
                      {!this.state.isPlaying && (
                        <FillBtnPlay className={this.state.selectBtn === 0 ? "activePlayer" : null} />
                      )}
                      {this.state.isPlaying && (
                        <FillBtnPause className={this.state.selectBtn === 0 ? "activePlayer" : null} />
                      )}
                    </ToggleBtn>
                  </PlayPauseToggle>
                )}
                {!isLive && (
                  <CurrentPlay currentState={this.state.currentTime.lastIndexOf(":")}>
                    <CurrentAndTotalPlaySpan>
                      {this.state.currentTime !== "NaNNaN:NaN" ? this.state.currentTime : "00:00"}
                    </CurrentAndTotalPlaySpan>
                  </CurrentPlay>
                )}
                <ProgressBarContainer>
                  <ProgressBar value={this.state.seekedTime} max={this.state.totalTimeInSeconds} />
                  {this.adBreaksStartTimes.length !== 0 && this.adBreaksStartTimes.length !== 0 && this.adMargin && (
                    <AdBreaksListStyled>
                      {this.adMargin.map((margin, i) => (
                        <AdBreaksStyled key={i} margin={margin} isAdExist={this.isAdexists() ? true : false} />
                      ))}
                    </AdBreaksListStyled>
                  )}
                </ProgressBarContainer>
                {!isLive && (
                  <TotalPlayTime>
                    <CurrentAndTotalPlaySpan>
                      {this.state.duration ? this.state.duration : "00:00"}
                    </CurrentAndTotalPlaySpan>
                  </TotalPlayTime>
                )}
              </LowerPlayerControls>
            )}
          </PlayerShadow>
        ) : (
          !this.shouldShowLoading() &&
          this.state.isPlayerLoaded &&
          this.isAdUIShown && (
            <PlayerShadowAds style={{ zIndex: 9 }}>
              <LowerPlayerControlsAds dir="ltr">
                <ButtonsAdsStyled className={"adsButtons"}>
                  {}
                  {}
                </ButtonsAdsStyled>
                {isFullScreen && (
                  <ProgressBarContainerAd>
                    <ProgressBarAd value={this.adSeekTime} max={this.adDurationinSeconds} />
                  </ProgressBarContainerAd>
                )}
                {isFullScreen && (
                  <AdInfoStyled>
                    <AdTag text={`${"&nbsp" + i18n.get("pages.player.ad") + "&nbsp"}`} />
                    <AdTextStyled>
                      {this.appFlow === "rtl" ? (
                        <>
                          <span> {this.totalAdsInAdBreak}</span>
                          <p>{i18n.get("pages.player.of")}</p>
                          <span>
                            {this.adCounter + 1 > this.totalAdsInAdBreak ? this.totalAdsInAdBreak : this.adCounter + 1}
                          </span>
                        </>
                      ) : (
                        <>
                          <span>
                            {this.adCounter + 1 > this.totalAdsInAdBreak ? this.totalAdsInAdBreak : this.adCounter + 1}
                          </span>
                          <p>{i18n.get("pages.player.of")}</p>
                          <span> {this.totalAdsInAdBreak}</span>
                        </>
                      )}
                      <AdDotStyled>&bull;</AdDotStyled> {this.adDuration}
                    </AdTextStyled>
                  </AdInfoStyled>
                )}
              </LowerPlayerControlsAds>
            </PlayerShadowAds>
          )
        )}
        <PlayerDiv
          id="av-player-mini"
          isFullScreen={this.props.isFullScreen}
          isRTL={this.appFlow === "rtl" ? true : false}
        />
      </Wrapper>
    );
  }
}
export default withAppState(LivePlayer);
